module.exports = __webpack_public_path__ + "static/media/search.00448b73.svg";